import { render, staticRenderFns } from "./VerifiedLandingPageView.vue?vue&type=template&id=61dc421d&scoped=true&"
import script from "./VerifiedLandingPageView.vue?vue&type=script&lang=js&"
export * from "./VerifiedLandingPageView.vue?vue&type=script&lang=js&"
import style0 from "./VerifiedLandingPageView.vue?vue&type=style&index=0&id=61dc421d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc421d",
  null
  
)

/* custom blocks */
import block0 from "./VerifiedLandingPageView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow})
